import { Moment } from "moment";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import FormBottomRow from "~/components/form-bottom-row";
import FormCard from "~/components/form-card";
import { ClientForm } from "~/components/forms/ClientForm";
import { ErrorRenderer } from "~/components/forms/MutationForm";
import PageTitleRow from "~/components/page-title-row";
import { useReportFetcher } from "~/report-fetcher/useReportFetcher";
import Spinner from "~/components/spinner";
import DatePickFormField from "~/visuals/organisms/DatePickFormField";

export const DailyProjectExportReport: React.FC = () => {
  const [loading, setLoading] = useState(false);

  const downloadReport = useReportFetcher();
  const navigate = useNavigate();

  const getCsv = async (date: Moment) => {
    await downloadReport({
      setLoading,
      path: "daily-project-export",
      fileName: `Projects Import ${date.format("MMDDYYYY")}.csv`,
      body: { date: date.format("YYYY-MM-DD") },
      type: "text/csv;charset=utf-8;",
    });
  };

  const onSuccess = async (values: { date: Moment | null }) => {
    await getCsv(values.date!);
  };

  return (
    <div>
      <PageTitleRow title="Daily Project Export" />
      <FormCard>
        <ClientForm
          {...{
            initialValues: { date: null },
            onSuccess,
          }}
        >
          <DatePickFormField
            formField={"date"}
            label={"Date"}
            helperText={""}
            required
          />
          <ErrorRenderer
            render={(error) => (
              <FormBottomRow
                errorMessage={error}
                buttonText={"Download Report"}
                onCancel={() => navigate("/")}
              />
            )}
          />
        </ClientForm>
      </FormCard>
      <Spinner open={loading} />
    </div>
  );
};
